import Checkbox from "common/components/Checkbox";
import React, { useMemo } from "react";
import TabMixCourses from "./TabMixCourses";
import BlockMixIcon from "assets/icons/bidding/blockMixBid.svg";

interface Props {
  setActiveTab?: any;
  setListChecked?: any;
  activeTab?: string;
  listChecked?: any[];
  sortedList?: any;
  onChecked?: any;
  onSubmit?: any;
}

const PracticeBiddingAllExercisesMobile = ({
  setActiveTab,
  activeTab,
  setListChecked,
  listChecked,
  sortedList,
  onChecked,
  onSubmit
}: Props) => {
  const listToDisplay = useMemo(() => {
    if (!sortedList) return [];
    switch (activeTab) {
      case "bidding":
        return sortedList.basicBidsList;
      case "bidding_interactive":
        return sortedList.interactiveBidsList;
      case "bid_play":
        return sortedList.bidPlayList;
      default:
        return [];
    }
  }, [activeTab, sortedList]);

  return (
    <div className="PracticeByCourses-main-mobile practiceByCourses-main-mobile-mix">
      <div>
        <TabMixCourses
          isMobile
          onSelect={(val) => {
            setActiveTab(val);
            setListChecked([]);
          }}
          activeTab={activeTab}
        />
        <div className="container-count-active-course">
          <span>קורסים נבחרו: {listChecked.length || 0}</span>
        </div>
        <div className="container-list-mix">
          {listToDisplay.map((val) => {
            if (!val) {
              return null;
            }
            const resLevels = localStorage.getItem("levels");
            const audit: number[] = [];
            if (resLevels) {
              const valLevel = JSON.parse(resLevels);
              if (valLevel?.ease) {
                audit.push(10);
              }
              if (valLevel?.medium) {
                audit.push(20);
              }
              if (valLevel?.hard) {
                audit.push(30);
              }
            }

            let isDisabled = false;

            if (
              audit?.length > 0 &&
              !audit.find((itemFind) => `${val?.Levels}`.indexOf(`${itemFind}`) !== -1)
            ) {
              isDisabled = true;
            }
            return (
              <div key={`${val?.Id}some${Math.random() * 10000}`} className="bidding-item-mix">
                {!isDisabled && (
                  <Checkbox
                    checked={!!listChecked.find((val_find) => val_find?.Id === val?.Id)}
                    label={val?.Name}
                    onClick={(item) => onChecked(val, item)}
                  />
                )}
                {isDisabled && (
                  <div className="bidding-item-mix-blocked bidding-item-mix-blocked-mobile">
                    <img src={BlockMixIcon} alt="Blocked" />
                    <span
                      style={{
                        fontWeight: 500,
                        fontSize: 20,
                        color: "#78659E"
                      }}>
                      {val?.Name}
                    </span>
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <div className="bidding-container-button bidding-container-button-mobile">
          <div
            className={`PracticeByTechniqueTab-btn ${
              listChecked.length <= 0 ? "PracticeByTechniqueTab-btn-disable" : ""
            }`}
            onClick={() => {
              if (listChecked.length > 0) {
                onSubmit && onSubmit();
              }
            }}>
            <span className="start-btn">התחילו לתרגל</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PracticeBiddingAllExercisesMobile;
